









































































import Vue from 'vue';
import _ from 'lodash';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { SazbaDph } from '@/modules/ciselnik/firemni/dphsazba';
import { showNotification } from '@/main/utils/notifications';
import { genVuexComputeds } from '@/main/pages/editFactory';

import DmsDphCalculator from '#components/dms/dphCalculator/DmsDphCalculator.vue';

import { types } from '../store/types';
import { store } from '../store/edit';

export default Vue.extend({
	name: 'ZakladniInformace',
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		DmsDphCalculator,
	},
	props: {
		storeUri: String,
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers() : Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_PRACOVNIK_SELECT_MAPPER}`,
				technik: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_TECHNIK_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		naklStredFilter(): { ProvozovnaId: number | null } {
			return { ProvozovnaId: this.ProvozovnaId };
		},
		dphSazba(): number {
			return (this.SazbyDph && this.DphSzbOzn && this.DphSzbOzn > -1) ? this.SazbyDph[this.DphSzbOzn].DphSzb : 0;
		},
	},
	async created() {
		await this.getDphSazby();
	},
	methods: {
		async getDphSazby() {
			if (this.SazbyDph !== null) return;
			try {
				const result = await SazbaDph.apiProvider.tableData();
				const sazby = {};
				_.forEach(result.data, (dataRow) => {
					// TODO: type.
					(sazby as any)[dataRow.Cells[1]] = { // DphSzbOzn
						DphSzb: dataRow.Cells[3],
					};
				});
				this.SazbyDph = sazby;
			} catch (err) {
				showNotification({ title: err.name, message: err.message });
			}
		},
	},
});
